import { object, z } from "zod";

import { LadyMinV2DTO, LadyMinV2DTORaw } from "@/models/lady-dtos";

export const SmallLadyResponseDTORaw = object({
  ladyDto: LadyMinV2DTORaw,
});
export const SmallLadyResponseDTO = SmallLadyResponseDTORaw.extend({
  ladyDto: LadyMinV2DTO,
});

export type SmallLadyResponseDTORaw = z.infer<typeof SmallLadyResponseDTORaw>;
export type SmallLadyResponseDTO = z.infer<typeof SmallLadyResponseDTO>;
